export const formatDownloadTaskBarCount = (
  bars: number | null | undefined,
  fallback = '',
): string => (
  typeof bars === 'number' && Number.isFinite(bars)
    ? bars.toLocaleString()
    : fallback
);
